import { render, staticRenderFns } from "./AccountingTransactionTypeForm.vue?vue&type=template&id=9956cb02&"
import script from "./AccountingTransactionTypeForm.vue?vue&type=script&lang=js&"
export * from "./AccountingTransactionTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountingTransactionTypeForm.vue?vue&type=style&index=0&id=9956cb02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports